import React, { useContext, useEffect, useState } from "react";

import { useToast } from "../ToastContext";
import Utils from "../../utils/utils";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

const EditProjectCard = ({ props }) => {
  const { item, index, setProjects, onClose } = props;
  const { Projects } = useAppLibs();
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const [docs, setDocs] = useState([{ name: "", url: "" }]);
  const [formData, setFormData] = useState({
    title: item.title,
    description: item.description,
    instruction: item.instruction,
    subject: item.subject,
    level: item.level,
    maxMarks: item.maxMarks,
  });
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;

  const [createClicked, setCreateClicked] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // =======================    APIs
  const HandleProjectUpdate = async (e) => {
    e.preventDefault();
    setCreateClicked((prev) => true);
    try {
      const result = await Projects.updateProject(item._id, formData);
      if (result.success) {
        const updated = result.data;
        setCreateClicked(false);
        setProjects((prev) =>
          prev.map((p) => (p._id === updated._id ? updated : p))
        );
        showToast("Project updated successfully!", "success", true, 2000);
        onClose();
      } else {
        setCreateClicked((prev) => false);
        showToast(result.error, "error", true, 5000);
      }
    } catch (error) {
      setCreateClicked(false);
      console.log("Error In catch in ProjectCreation: ", error);
      alert(`Something went wrong !!`);
    }
  };

  return (
    <div bkl="CreateProjectForm">
      <div className="menu bg-[#FFFFFF] text-base-content w-full h-full p-4 rounded-l-lg">
        <div>
          <p className="text-lg bold">Create a new Project</p>
        </div>
        <form onSubmit={HandleProjectUpdate} className="h-full">
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Project Name :</span>
              <input
                name="title"
                value={formData.title.trim()}
                onChange={handleInputChange}
                required
                placeholder="Please enter title project title.."
                className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Description :</span>
              <textarea
                name="description"
                value={formData.description.trim()}
                onChange={handleInputChange}
                placeholder="Please enter the description of the project.."
                className="w-full px-4 py-2 min-h-12 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Instruction :</span>
              <textarea
                name="instruction"
                value={formData.instruction.trim()}
                onChange={handleInputChange}
                placeholder="Enter the instruction optional.."
                className="w-full px-4 py-2 min-h-12 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-[40%]">
              <span className="label ">Project In :</span>
              <select
                name="subject"
                value={formData.subject || ""}
                onChange={handleInputChange}
                className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
              >
                <option
                  value={""}
                  key={"Select Subject"}
                  disabled
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  Select Subject
                </option>
                {Object.keys(SUBJECT).map((sub) => (
                  <option value={sub} key={sub}>
                    {SUBJECT[sub]}
                  </option>
                ))}
              </select>
            </label>
            <label className="form-control w-[40%]">
              <span className="label ">Difficulty :</span>
              <select
                name="level"
                value={formData.level || ""}
                onChange={handleInputChange}
                className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
              >
                <option
                  value={""}
                  key={"Select Difficulty"}
                  disabled
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  Select Difficulty
                </option>
                {Object.keys(LEVEL).map((sub) => (
                  <option value={sub} key={sub}>
                    {LEVEL[sub].name}
                  </option>
                ))}
              </select>
            </label>
            <label className="form-control w-[20%] transition-all duration-200">
              <span className="label ">Maximum Marks :</span>
              <input
                type="tel"
                placeholder="Max Marks"
                value={formData.maxMarks}
                pattern="[0-9]*"
                inputMode="numeric"
                name="maxMarks"
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleInputChange(e);
                  } else {
                    alert("Please enter numbers only.");
                    return false;
                  }
                }}
                className="input-sm max-w-[120px] px-2 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div className="gap-2 bg-white mt-4 z-10 flex justify-between sticky bottom-1">
            <div className="flex gap-2">
              <button
                className={`${
                  createClicked ? "cursor-not-allowed" : "cursor-pointer"
                } px-3 py-2 flex justify-center items-center gap-1 tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-600 hover:text-green-800 hover:border-green-800 hover:shadow-lg`}
                type="submit"
                disabled={createClicked}
              >
                UPDATE
              </button>
              <label
                htmlFor="my-drawer-8"
                aria-label="close sidebar"
                className="px-3 py-2 flex cursor-pointer justify-center items-center gap-1 tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg "
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onClose();
                  // handleResetForm();
                }}
              >
                CLOSE
              </label>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditProjectCard;
